export const alertConsts = {
  SHOW_WARNING: '[Alert] SHOW_WARNING',
  SHOW_ERROR:   '[Alert] SHOW_ERROR',
  SHOW_SUCCESS: '[Alert] SHOW_SUCCESS',
  CLEAR_ALL:    '[Alert] CLEAR_ALL',
  CLEAR_NOTIFICATION: '[Alert] CLEAR_NOTIFICATION',
  CLEAR_BY_TYPE: '[Alert] CLEAR_BY_TYPE'
};
